import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getUsersPaginated = ({
  churchId,
  page,
  pageSize,
  isDenomination = false,
  denominationId
}) => {
  return axios.get(
    `/${isDenomination ? "denominations" : "churches"}/${
      isDenomination ? denominationId : churchId
    }/users-paginated?page=${page}&per_page=${pageSize}`
  );
};

export const useUsersPaginated = ({
  churchId,
  page,
  pageSize,
  isDenomination = false,
  denominationId,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: [
      "users",
      page,
      pageSize,
      isDenomination ? denominationId : churchId
    ],
    queryFn: () =>
      getUsersPaginated({
        churchId,
        page,
        pageSize,
        isDenomination,
        denominationId
      })
  });
};
